import { ScheduleItemDirectionEnum } from '@/components/Schedule/enums';
import { IScheduleItem } from '@/typings/timit';

export default class ScheduleItem implements IScheduleItem {
  id: number;
  scheduleId: number;
  dayOfWeek: number;
  direction: ScheduleItemDirectionEnum;
  time: number;

  private originalTime: number;

  constructor(options) {
    this.id = options && options.id ? options.id : 0;
    this.scheduleId = options && options.scheduleId ? options.scheduleId : 0;
    this.dayOfWeek = options && options.dayOfWeek ? options.dayOfWeek : 0;
    this.direction = options && options.direction ? options.direction : ScheduleItemDirectionEnum.Start;
    this.time = options && options.time ? options.time : null;
    this.originalTime = this.time;
  }

  get isEdited() {
    return this.originalTime !== this.time && !(this.originalTime === null && this.time === undefined);
  }

}
